import React, { createContext, useContext, useState } from "react";
import { getAppLoginParam } from "@/utils/startParam";
import { requireContext, type MainScreen, type WithChildren } from "./shared";

type MainScreenContextValue = {
  screen: MainScreen;
  setScreen: React.Dispatch<React.SetStateAction<MainScreen>>;
};

const MainScreenContext = createContext<MainScreenContextValue | null>(null);

export function useMainScreenContext() {
  return requireContext(useContext(MainScreenContext), "useMainScreenContext");
}

export function MainScreenProvider({ children }: WithChildren) {
  // открыли по ссылке входа из BK VPN (startapp=applogin_<код>) — сразу экран подтверждения
  const [screen, setScreen] = useState<MainScreen>(() =>
    getAppLoginParam() ? "app-login" : "main"
  );

  return (
    <MainScreenContext.Provider value={{ screen, setScreen }}>
      {children}
    </MainScreenContext.Provider>
  );
}
